module.exports = __webpack_public_path__ + "static/media/lanaLogo.3c1c2e36.png";